import { render, staticRenderFns } from "./author.vue?vue&type=template&id=2b526644&scoped=true"
import script from "./author.vue?vue&type=script&lang=js"
export * from "./author.vue?vue&type=script&lang=js"
import style0 from "./author.vue?vue&type=style&index=0&id=2b526644&prod&lang=scss&scoped=true"
import style1 from "./author.vue?vue&type=style&index=1&id=2b526644&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b526644",
  null
  
)

export default component.exports